import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
import cognito from '@/cognito'
import apig from '@/apig'
import signup from '@/components/signup'
import login from '@/components/login'
import dashboard from '@/components/dashboard'
import smartthon from '@/components/smartthon'
import preview from '@/components/preview'
import edit from '@/components/edit'
import report from '@/components/report'
import reportDetail from '@/components/report/detail'
import ceremony from '@/components/report/ceremony'
import ceremonyPreview from '@/components/report/ceremony/preview'
import proposal from '@/components/report/detail/proposal'
import review from '@/components/report/review'
import grade from '@/components/report/review/grade'
import intern from '@/components/intern'
import internDetail from '@/components/intern/detail'
import skill from '@/components/skill'
import skillCreate from '@/components/skill/create'
import skillDetail from '@/components/skill/detail'
import skillEdit from '@/components/skill/edit'
import scout from '@/components/intern/scout'
import baseSettings from '@/components/settings/base'
import pageSettings from '@/components/settings/page'
import chat from '@/components/chat'
import swipe from '@/components/swipe'
import swipeEdit from '@/components/swipe/edit'
import swipeDetail from '@/components/swipe/detail'
import like from '@/components/like'
import profile from '@/components/profile'
import stepOne from '@/components/register/step-1'
import stepTwo from '@/components/register/step-2'
import complete from '@/components/register/complete'
import stepThree from '@/components/register/step-3'
import plan from '@/components/plan'
import terms from '@/components/terms'

Vue.use(Router)

const requireAuth = (to, from, next) => {
  store.commit('onMovingChanged', true)

  let additionalParams = {
    queryParams: {
      type: 'auth'
    }
  }
  let body = {
    email: store.getters.user.email
  }
  apig.patch(store.getters.api.LOGIN, {}, additionalParams, body)
    .then(response => {
      store.commit('onVersionChanged', response.data.version)
      store.commit('onUserStateChanged', {
        enterpriseId: response.data.enterprise.enterpriseId,
        name: response.data.enterprise.name,
        email: response.data.enterprise.email,
        photoFlag: response.data.enterprise.photoFlag,
        address: response.data.enterprise.address,
        plan: response.data.enterprise.plan,
        planId: response.data.enterprise.planId,
        swipe: response.data.enterprise.swipeCount
      })
      store.commit('onAvatarStateChanged', response.data.enterprise.avatarId)
      store.commit('onLoginStatusChanged', true)

      switch (response.data.enterprise.termsFlag) {
        case 0:
          store.commit('onMovingChanged', false)
          if (to.path === '/register/step-1') next()
          else next('/register/step-1')
          break
        case 1:
          store.commit('onMovingChanged', false)
          if (to.path === '/register/step-2') next()
          else next('/register/step-2')
          break
        case 2:
          if (to.path === '/register/step-1' || to.path === '/register/step-2') {
            store.commit('onMovingChanged', false)
            next(`/home`)
          }

          apig.get(store.getters.api.NOTIFICATION, {}, {}, {})
            .then(response => {
              store.commit('onNotificationStateChanged', response.data)
              store.commit('onMovingChanged', false)
              next()
            })
            .catch(err => {
              console.error(err)
            })
      }
    })
    .catch((err) => {
      console.log(err)
      forceLogout(to, next)
    })
}

const forceLogout = (to, next) => {
  store.commit('onLoginStatusChanged', false)
  store.commit('onMovingChanged', false)
  next({
    path: '/logout'
  })
}

const checkAuth = (to, from, next) => {
  store.commit('onMovingChanged', false)
  cognito.isAuthenticated()
    .then(() => {
      next('/dashboard')
    })
    .catch(() => {
      next()
    })
}

const checkLogin = (to, from, next) => {
  store.commit('onMovingChanged', true)

  cognito.isAuthenticated()
    .then(() => {
      let additionalParams = {
        queryParams: {
          type: 'auth'
        }
      }

      let body = {
        email: store.getters.user.email
      }

      apig.patch(store.getters.api.LOGIN, {}, additionalParams, body)
        .then(response => {
          store.commit('onUserStateChanged', {
            enterpriseId: response.data.enterprise.enterpriseId,
            name: response.data.enterprise.name,
            email: response.data.enterprise.email,
            photoFlag: response.data.enterprise.photoFlag,
            address: response.data.enterprise.address,
            plan: response.data.enterprise.plan,
            planId: response.data.enterprise.planId,
            swipe: response.data.enterprise.swipeCount
          })
          store.commit('onAvatarStateChanged', response.data.enterprise.avatarId)
          store.commit('onLoginStatusChanged', true)
          apig.get(store.getters.api.NOTIFICATION, {}, {}, {})
            .then(response => {
              store.commit('onNotificationStateChanged', response.data)
              store.commit('onMovingChanged', false)
              next()
            })
            .catch(err => {
              console.error(err)
            })
        })
    })
    .catch(() => {
      store.commit('onLoginStatusChanged', false)
      store.commit('onMovingChanged', false)
      next()
    })
}

const activateEmail = (to, from, next) => {
  store.commit('onMovingChanged', false)
  let email = decodeURIComponent(to.query.email)
  let code = to.query.confirmation_code
  cognito.confirmRegistration(email, code)
    .then(() => {
      next('/login?activate=true')
    })
    .catch(() => {
      next()
    })
}

const logout = (to, from, next) => {
  store.commit('onLoginStatusChanged', false)
  store.commit('onMovingChanged', false)
  cognito.logout()
  next('/login')
}

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      redirect: 'dashboard'
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      beforeEnter: checkAuth
    },
    {
      path: '/signup',
      name: 'signup',
      component: signup,
      beforeEnter: checkAuth
    },
    {
      path: '/activate',
      beforeEnter: activateEmail
    },
    {
      path: '/register/step-1',
      component: stepOne,
      name: 'stepOne',
      beforeEnter: requireAuth
    },
    {
      path: '/register/step-2',
      component: stepTwo,
      name: 'stepTwo',
      beforeEnter: requireAuth
    },
    {
      path: '/register/complete',
      component: complete,
      name: 'complete',
      beforeEnter: requireAuth
    },
    {
      path: '/register/step-3',
      component: stepThree,
      name: 'stepThree',
      beforeEnter: requireAuth
    },
    {
      path: '/dashboard',
      component: dashboard,
      name: 'dashboard',
      beforeEnter: requireAuth
    },
    {
      path: '/smartthon',
      component: smartthon,
      name: 'smartthon',
      beforeEnter: requireAuth
    },
    {
      path: '/preview/:enterpriseId/:smartthonId',
      component: preview,
      name: 'preview',
      beforeEnter: checkLogin
    },
    {
      path: '/smartthon/:smartthonId/edit',
      component: edit,
      name: 'edit',
      beforeEnter: requireAuth
    },
    {
      path: '/report',
      component: report,
      name: 'report',
      beforeEnter: requireAuth
    },
    {
      path: '/report/:smartthonId/detail',
      component: reportDetail,
      name: 'reportDetail',
      beforeEnter: requireAuth
    },
    {
      path: '/report/:smartthonId/detail/:studentId',
      component: proposal,
      name: 'proposal',
      beforeEnter: requireAuth
    },
    {
      path: '/report/:smartthonId/ceremony',
      component: ceremony,
      name: 'ceremony',
      beforeEnter: requireAuth
    },
    {
      path: '/report/:smartthonId/ceremony/preview',
      component: ceremonyPreview,
      name: 'ceremonyPreview',
      beforeEnter: requireAuth
    },
    {
      path: '/review/:enterpriseId/:smartthonId',
      component: review,
      name: 'review',
      beforeEnter: checkLogin
    },
    {
      path: '/review/:enterpriseId/:smartthonId/:studentId',
      component: grade,
      name: 'grade',
      beforeEnter: checkLogin
    },
    {
      path: '/intern',
      name: 'intern',
      component: intern,
      beforeEnter: checkLogin
    },
    {
      path: '/intern/:internId',
      name: 'internDetail',
      component: internDetail,
      beforeEnter: checkLogin
    },
    {
      path: '/intern/:internId/scout',
      name: 'scout',
      component: scout,
      beforeEnter: requireAuth
    },
    {
      path: '/skill',
      name: 'skill',
      component: skill,
      beforeEnter: requireAuth
    },
    {
      path: '/skill/create',
      name: 'skillCreate',
      component: skillCreate,
      beforeEnter: requireAuth
    },
    {
      path: '/skill/:skillId',
      name: 'skillDetail',
      component: skillDetail,
      beforeEnter: requireAuth
    },
    {
      path: '/skill/:skillId/edit',
      name: 'skillEdit',
      component: skillEdit,
      beforeEnter: requireAuth
    },
    {
      path: '/settings/base',
      component: baseSettings,
      name: 'baseSettings',
      beforeEnter: requireAuth
    },
    {
      path: '/settings/page',
      component: pageSettings,
      name: 'pageSettings',
      beforeEnter: requireAuth
    },
    {
      path: '/chat',
      component: chat,
      name: 'chat',
      beforeEnter: requireAuth
    },
    {
      path: '/swipe',
      component: swipe,
      name: 'swipe',
      beforeEnter: requireAuth
    },
    {
      path: '/swipe/edit',
      component: swipeEdit,
      name: 'swipeEdit',
      beforeEnter: requireAuth
    },
    {
      path: '/swipe/detail/:swipeId',
      component: swipeDetail,
      name: 'swipeDetail',
      beforeEnter: requireAuth
    },
    {
      path: '/like',
      component: like,
      name: 'like',
      beforeEnter: requireAuth
    },
    {
      path: '/profile/:studentId',
      component: profile,
      name: 'profile',
      beforeEnter: requireAuth
    },
    {
      path: '/plan',
      component: plan,
      name: 'plan',
      beforeEnter: checkLogin
    },
    {
      path: '/terms',
      name: 'terms',
      component: terms
    },
    { path: '/logout',
      beforeEnter: logout
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js